/*global VeloxGridAndFormController*/

var videoController = new VeloxGridAndFormController("video", {
    grid : {
        directory: "views/video",
        name: "videoGrid"
    },
    form : {
        directory: "views/video",
        name: "videoForm"
    }
});

module.exports = videoController ;